export const CRM = 'crm';
export const COMMUNICATOR = 'communicator';
export const SETTINGS = 'settingsui';
export const LISTS = 'lists';
export const PRODUCTS = 'products';
export const LINEITEMS = 'line-items';
export const REPORTING = 'reporting';
export const TASKS = 'tasks';